import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/site";

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="border-y border-stone-200 bg-stone-100 py-7" aria-hidden="true">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
          <span key={i} className="mx-12 flex items-center gap-24">
            <span className="font-serif text-2xl font-light italic text-stone-700">{item}</span>
            <span className="inline-block h-2 w-2 rotate-45 bg-brand-bronze/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
